<div class="ui-virtual-repeat-offset-before"
     [style.height]="scrollHeight + 'px'">
</div>
<div class="ui-virtual-repeat-content"
     #content
     [style.transform]="'translateY(' + contentYOffset + 'px)'">
  <ng-content></ng-content>
</div>
